import { Box, Typography } from "@mui/material";
import { orderFlagColor } from "../../utils/Constant";
import OrderFlag from "./order-flag";

export default function OrderTableClientCell({ rowData }: any) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", height: "inherit" }}>
        {rowData?.client?.isVip && <OrderFlag color={orderFlagColor.vipClient} />}
        <Typography noWrap sx={{ ml: 1, maxWidth: 160 }}>
          {rowData?.client?.clientName || ""}
        </Typography>
      </Box>
    );
  };